module.exports = __webpack_public_path__ + "static/media/DSC02317.bcfed44b.jpg";